/*eslint-disable no-undef*/
import React, { Component } from 'react';

class Page3 extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount(){
    window.deeploop.page("Page 3");
  }

  render() {
    return (
      <div>
          This is page #3
      </div>
    )
  }
}

export default Page3;


// WEBPACK FOOTER //
// ./src/components/Page3.jsx